
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BcDocumentType } from 'enums/BcDocumentType';
import { Model, ModelProperty } from 'models/Model';


export class DebtCollectionReadyInvoicesDtoModel extends Model<DebtCollectionReadyInvoicesDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'ledgerHeaderId', type: 'string' },
		{ name: 'documentNo', type: 'string' },
		{ name: 'entryNo', type: 'number' },
		{ name: 'remainingAmountInclVat', type: 'number' },
		{ name: 'originalAmountInclVat', type: 'number' },
		{ name: 'originalDueDate', type: 'Date' },
		{ name: 'customerNo', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'postingDate', type: 'Date' },
		{ name: 'documentType', type: 'BcDocumentType' },
		{ name: 'dueDate', type: 'Date' },
		{ name: 'objectionReasonId', type: 'string' }
	];
	[key: string]: any;
	
	public ledgerHeaderId?: string;
	public documentNo: string;
	public entryNo: number;
	public remainingAmountInclVat?: number;
	public originalAmountInclVat?: number;
	public originalDueDate?: Date;
	public customerNo: string;
	public companyId?: string;
	public postingDate?: Date;
	public documentType: BcDocumentType;
	public dueDate?: Date;
	public objectionReasonId?: string;
    
	constructor(){
		super();
		this.ledgerHeaderId = undefined;
		this.documentNo = '';
		this.entryNo = 0;
		this.remainingAmountInclVat = undefined;
		this.originalAmountInclVat = undefined;
		this.originalDueDate = undefined;
		this.customerNo = '';
		this.companyId = undefined;
		this.postingDate = undefined;
		this.documentType = 0;
		this.dueDate = undefined;
		this.objectionReasonId = undefined;
		
	}
	getProperties(){
		return DebtCollectionReadyInvoicesDtoModel.classProperties;
	}
}
export class DebtCollectionDtoModel extends Model<DebtCollectionDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyName', type: 'string' },
		{ name: 'vatNumber', type: 'string' },
		{ name: 'address', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'contact', type: 'string' },
		{ name: 'zipcode', type: 'string' },
		{ name: 'emailAddress', type: 'string' },
		{ name: 'businessStatus', type: 'string' },
		{ name: 'count', type: 'number' },
		{ name: 'objectionReasonName', type: 'string' },
		{ name: 'inDebtCollection', type: 'boolean' }
	];
	[key: string]: any;
	
	public companyName: string;
	public vatNumber: string;
	public address: string;
	public city: string;
	public contact: string;
	public zipcode: string;
	public emailAddress: string;
	public businessStatus: string;
	public count: number;
	public objectionReasonName: string;
	public inDebtCollection: boolean;
    
	constructor(){
		super();
		this.companyName = '';
		this.vatNumber = '';
		this.address = '';
		this.city = '';
		this.contact = '';
		this.zipcode = '';
		this.emailAddress = '';
		this.businessStatus = '';
		this.count = 0;
		this.objectionReasonName = '';
		this.inDebtCollection = false;
		
	}
	getProperties(){
		return DebtCollectionDtoModel.classProperties;
	}
}

